import React from 'react';

// Построчное сравнение before/after для журнала аудита: изменённые и
// добавленные/удалённые листовые значения подсвечиваются (красным в Before,
// зелёным в After), чтобы в длинных записях было видно, что именно поменялось.

// Собирает пути листьев ('a.b.0.c'), значения которых различаются или есть
// только с одной стороны.
function collectDiffPaths(a, b, path, out) {
    const aObj = a !== null && typeof a === 'object';
    const bObj = b !== null && typeof b === 'object';
    if (!aObj && !bObj) {
        if (a !== b) out.add(path);
        return;
    }
    if (aObj !== bObj) {
        markAll(a, path, out);
        markAll(b, path, out);
        return;
    }
    const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
    for (const k of keys) {
        const p = path ? `${path}.${k}` : String(k);
        if (!(k in a)) markAll(b[k], p, out);
        else if (!(k in b)) markAll(a[k], p, out);
        else collectDiffPaths(a[k], b[k], p, out);
    }
}

function markAll(v, path, out) {
    if (v !== null && typeof v === 'object') {
        const keys = Object.keys(v);
        if (keys.length === 0) out.add(path);
        for (const k of keys) markAll(v[k], path ? `${path}.${k}` : String(k), out);
    } else {
        out.add(path);
    }
}

function buildLines(value, path, label, indent, lines) {
    const prefix = label !== null ? `${label}: ` : '';
    if (value === null || typeof value !== 'object') {
        lines.push({ path, indent, text: prefix + JSON.stringify(value), leaf: true });
        return;
    }
    const isArr = Array.isArray(value);
    const keys = isArr ? value.map((_, i) => String(i)) : Object.keys(value);
    lines.push({ path, indent, text: prefix + (isArr ? '[' : '{'), leaf: keys.length === 0 });
    for (const k of keys) {
        buildLines(value[k], path ? `${path}.${k}` : k, isArr ? null : k, indent + 1, lines);
    }
    lines.push({ path: `${path}.__close`, indent, text: isArr ? ']' : '}', leaf: false });
}

function Pane({ value, diffs, side }) {
    const lines = [];
    buildLines(value === undefined ? null : value, '', null, 0, lines);
    return (
        <div className="json-diff">
            {lines.map((l, i) => (
                <div
                    key={i}
                    className={`json-diff__line${l.leaf && diffs.has(l.path) ? ` is-diff-${side}` : ''}`}
                    style={{ paddingLeft: 8 + l.indent * 14 }}
                >
                    {l.text}
                </div>
            ))}
        </div>
    );
}

function JsonDiff({ before, after }) {
    const diffs = new Set();
    collectDiffPaths(before === undefined ? null : before, after === undefined ? null : after, '', diffs);
    return (
        <>
            <div className="audit-details__col">
                <div className="audit-details__label">Before</div>
                <Pane value={before} diffs={diffs} side="before" />
            </div>
            <div className="audit-details__col">
                <div className="audit-details__label">After</div>
                <Pane value={after} diffs={diffs} side="after" />
            </div>
        </>
    );
}

export default JsonDiff;
export { collectDiffPaths };
